/** @jsx jsx */
import IconError from '@apollo/icons/default/IconError.svg';
import IconSuccess from '@apollo/icons/default/IconSuccess.svg';
import IconUnavailable from '@apollo/icons/default/IconUnavailable.svg';
import IconWarning from '@apollo/icons/default/IconWarning.svg';
import { css, jsx, keyframes } from '@emotion/react';
import classnames from 'classnames';

import { assertUnreachable } from 'src/lib/assertUnreachable';

// TODO(tim): this should probably be supplied by the API?
export enum LaunchSequenceStepStatus {
  QUEUED = 'QUEUED',
  INTIATED = 'INITIATED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_WARNING = 'COMPLETED_WITH_WARNING',
  SUPERSEDED = 'SUPERSEDED',
}
interface Props {
  className?: string;
  status: LaunchSequenceStepStatus;
}

const publishingPulse = keyframes`
  0%, 30% {
    transform: scale(1);
    border-width: 1.5px;
    opacity: 1;
  }

  40% {
    border-width: 2px;
  }

  50%, 60% {
    /* opacity: 0.2; */
    border-width: 6px;
  }

  65%, 70%, 100% {
    opacity: 0;
  }

  70%, 100% {
    transform: scale(0.7);
    border-width: 10px;
  }
`;

export function LaunchEntryStatusIcon({ className, status }: Props) {
  switch (status) {
    case LaunchSequenceStepStatus.QUEUED:
      return (
        <div
          className={classnames(
            className,
            'rounded-full border border-primary',
          )}
        />
      );
    case LaunchSequenceStepStatus.INTIATED:
      return (
        <div
          className={classnames(className, 'flex items-center justify-center')}
        >
          <div
            className="absolute size-4 rounded-full border border-info"
            css={css`
              animation: 1s ${publishingPulse} ease-in-out infinite alternate;
            `}
          />
          <div className="size-2 rounded-full bg-icon-info" />
        </div>
      );
    case LaunchSequenceStepStatus.COMPLETED:
      return (
        <IconSuccess className={classnames(className, 'text-icon-success')} />
      );
    case LaunchSequenceStepStatus.COMPLETED_WITH_WARNING:
      return (
        <IconWarning className={classnames(className, 'text-icon-warning')} />
      );
    case LaunchSequenceStepStatus.SUPERSEDED:
      return (
        <IconUnavailable
          className={classnames(className, 'text-icon-disabled')}
        />
      );
    case LaunchSequenceStepStatus.FAILED:
      return <IconError className={classnames(className, 'text-icon-error')} />;
    default:
      assertUnreachable(status);
  }
}
